/* eslint-disable no-await-in-loop */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from "react"
import { ComponentRefPair, PageConfig } from "../models/pageConfig"
import { PageConfigModel } from "../models/pageConfig"
import { Service } from "./Service"
import StoreService from "./store"
import ActionService from "./action"
import { Action } from "../models/action"
import { NavigationParam } from "../models/navigationParam"
import { ProviderService } from "./provider"

class ComponentService extends Service {
    private static instance: ComponentService
    private componentsRef: Array<ComponentRefPair> = []
    private navParam: NavigationParam
    private pageConfigService

    constructor() {
        super()
        // set le nom du service
        this.name = "ComponentService"
        // ajoute toute les methodes du service au tableau de mapping
        this.serviceMap = []
        const navParamService = ProviderService.getInstance().get(
            "NavigationParamService"
        )
        this.navParam = navParamService ? navParamService.getInstance() : null
        const pageConfigServiceInstance =
            ProviderService.getInstance().get("PageConfigService")
        this.pageConfigService = pageConfigServiceInstance.getInstance()
    }

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): ComponentService {
        if (!this.instance) {
            this.instance = new ComponentService()
        }
        return this.instance
    }

    /**
     * getPageConfig Donne la config de la page en fonction du nom de cette page
     * @param pageName Nom de la page à récupèrer
     */
    public getPageConfig = async (
        pageName: string
    ): Promise<PageConfigModel | undefined> => {
        const parsedUrl = this.navParam.get()
        if (StoreService.getInstance().local.getSession(`pconf_${pageName}`))
            return StoreService.getInstance().local.getSession(
                `pconf_${pageName}`
            )

        try {
            const resPageConfig: PageConfigModel | undefined = parsedUrl.params
                ?.link_auth
                ? await this.pageConfigService.getPageConfig(
                      pageName,
                      parsedUrl.params.link_auth
                  )
                : await this.pageConfigService.getPageConfig(pageName)

            StoreService.getInstance().local.setSession(
                `pconf_${pageName}`,
                resPageConfig
            )
            return resPageConfig
        } catch (err) {
            console.log("Error while trying to get the page config", err)
            return undefined
        }
    }

    /**
     * getPageConfig Crée un composant React, l'ajoute dans le tableau des ref et le renvoie
     * @param pageName Nom de la page à récupèrer
     */
    public create = (componentConfig: PageConfig<any>): React.JSX.Element => {
        let reactElement: React.JSX.Element
        // recherche dans les ref de composants disponibles le composant à injecter
        const componentRefPair: ComponentRefPair | undefined =
            this.componentsRef.find((pair: ComponentRefPair) => {
                return componentConfig.type === pair.key
            })

        // si le composant à été trouvé on le crée
        if (componentRefPair) {
            // Extract key from componentConfig to avoid React warning about spreading key prop
            // React.createElement handles key correctly when it's in the props object
            // The warning only occurs with JSX spread syntax, not with React.createElement
            const { key, ...propsWithoutKey } = componentConfig
            // Create element without key in props, then clone with key if needed
            // This prevents the warning while maintaining proper key behavior
            const elementWithoutKey = React.createElement(
                componentRefPair.componentRef,
                propsWithoutKey
            )
            // If key was provided, clone the element with the key
            reactElement = key
                ? React.cloneElement(elementWithoutKey, { key })
                : elementWithoutKey
        } else {
            throw Error(
                `Component ${componentConfig?.type} not found, page ${componentConfig?.name}`
            )
        }

        return reactElement
    }

    /**
     * add ajoute une pair clef ref de composant au tableau
     * @param componentRefPair pair key / ref de composant
     */
    public addRef = (componentRefPair: ComponentRefPair): void => {
        // on récupère l'index du tableau de la cléf donnée en paramètre
        const composantRefPairIndex: number = this.componentsRef.findIndex(
            (pair: ComponentRefPair) => {
                return pair.key === componentRefPair.key
            }
        )

        // si une clef de ce nom existe déjà on met à jour sinon on push la nouvelle valeur
        if (composantRefPairIndex > -1) {
            this.componentsRef[composantRefPairIndex] = componentRefPair
        } else {
            this.componentsRef.push(componentRefPair)
        }
    }

    /**
     * clear supprime tous les composants
     */
    public clear = (): void => {
        // clear les données paragées de ces composants
        StoreService.getInstance().clearSharedData()
    }

    /**
     * createContext ajoute les context dans le SharedData du Store
     * @param context liste des context a créer
     */
    public async createContext(
        context: Array<{
            key: string
            value: Array<Action> | string | boolean | number
        }>
    ) {
        // création des contextes
        for (let index = 0; index < context.length; index += 1) {
            const pair = context[index]
            let actionResult = pair.value

            // on verifie le type de la valeur
            if (Array.isArray(pair.value)) {
                actionResult = await ActionService.exec(pair.value)
            }

            StoreService.getInstance().local.set(pair.key, actionResult)
        }
    }
}

export default ComponentService
